<div class="login-container">
  <p-card styleClass="login-card">
    <ng-template pTemplate="header">
      <div class="card-header-title">
        {{ useRecoveryCode() ? 'Recovery Code' : 'Two-Factor Authentication' }}
      </div>
    </ng-template>
    <div class="login-body">
      <p>
        {{
          useRecoveryCode()
            ? 'Enter one of your 10-character recovery codes to sign in.'
            : 'Enter the 6-digit code from your authenticator app.'
        }}
      </p>
      @if (verifyError(); as error) {
        <app-error-banner [message]="error" />
      }
      <form [formGroup]="verifyForm" (ngSubmit)="onSubmit()">
        @if (!useRecoveryCode()) {
          <div class="field">
            <p-inputotp
              formControlName="code"
              [length]="6"
              [integerOnly]="true"
              [autofocus]="true"
              [pt]="{ pcInputText: { root: { 'aria-label': 'Authenticator code digit' } } }"
            />
          </div>
        } @else {
          <div class="field">
            <input
              pInputText
              formControlName="recoveryCode"
              placeholder="XXXXX-XXXXX"
              aria-label="Recovery code"
              autocomplete="one-time-code"
            />
          </div>
        }
        <p-button
          type="submit"
          [label]="useRecoveryCode() ? 'Verify & Login' : 'Verify'"
          [disabled]="verifyForm.invalid || loading()"
          [loading]="loading()"
          styleClass="p-button-secondary"
        />
      </form>
      <p-button
        [label]="useRecoveryCode() ? 'Use authenticator app' : 'Lost access to authenticator?'"
        (click)="toggleMethod()"
        styleClass="p-button-text p-button-secondary"
      />
      <p-button
        label="Back to login"
        icon="pi pi-arrow-left"
        routerLink="/login"
        styleClass="p-button-text p-button-secondary"
      />
    </div>
  </p-card>
</div>
